import { useState, useEffect } from 'react';
import api from '../../services/api';
import Button from '../../components/Button';
import Input from '../../components/Input';
import Select from '../../components/Select';

export default function UpdateByDepartment() {
  const [departments, setDepartments] = useState<any[]>([]);
  const [departmentId, setDepartmentId] = useState('');
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [sort, setSort] = useState('code');
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [edits, setEdits] = useState<Record<string, any>>({});

  useEffect(() => {
    api.get('/masters/departments').then((r) => setDepartments(r.data.departments || []));
  }, []);

  const fetchRows = async () => {
    setLoading(true);
    try {
      const res = await api.get('/tms/attendance/department', { params: { departmentId: departmentId || undefined, date, sort } });
      setRows(res.data.attendance || []);
      setEdits({});
    } finally {
      setLoading(false);
    }
  };

  const setEdit = (employeeId: string, field: string, value: any) => {
    setEdits((prev) => ({ ...prev, [employeeId]: { ...prev[employeeId], [field]: value } }));
  };

  const saveRow = async (row: any) => {
    const change = edits[row.employee_id];
    if (!change || !row.id) return;
    await api.put(`/tms/attendance/${row.id}`, change);
    fetchRows();
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">Update by Department</h1>

      <div className="bg-white rounded-lg shadow p-4 mb-4 flex gap-3 items-end flex-wrap">
        <Select label="Department" value={departmentId} onChange={(e) => setDepartmentId(e.target.value)} options={departments.map((d) => ({ value: d.id, label: d.name }))} placeholder="All departments" />
        <Input label="Date" type="date" value={date} onChange={(e) => setDate(e.target.value)} />
        <Select label="Sort" value={sort} onChange={(e) => setSort(e.target.value)} options={[{ value: 'code', label: 'Employee Code' }, { value: 'name', label: 'Name' }]} />
        <Button onClick={fetchRows} loading={loading}>Load</Button>
      </div>

      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="min-w-full text-xs">
          <thead>
            <tr className="border-b bg-gray-50">
              <th className="p-2 text-left">Code</th>
              <th className="p-2 text-left">Name</th>
              <th className="p-2">In</th>
              <th className="p-2">Out</th>
              <th className="p-2">Reason</th>
              <th className="p-2">NRM</th>
              <th className="p-2">Lateness</th>
              <th className="p-2">Under</th>
              <th className="p-2">OT Total</th>
              <th className="p-2">Save</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const rowEdits = edits[r.employee_id] || {};
              const val = (field: string, column: string) => (rowEdits[field] !== undefined ? rowEdits[field] : r[column]);
              const otTotal = (Number(r.ot_1_0_hours) || 0) + (Number(r.ot_1_5_hours) || 0) + (Number(r.ot_2_0_hours) || 0) + (Number(r.ot_3_0_hours) || 0) + (Number(r.flat_ot_hours) || 0);
              return (
                <tr key={r.employee_id} className="border-b">
                  <td className="p-2">{r.employee_code}</td>
                  <td className="p-2 whitespace-nowrap">{r.first_name} {r.last_name}</td>
                  <td className="p-1"><input className="w-20 border rounded px-1" value={val('clockInTime', 'clock_in_time') || ''} onChange={(e) => setEdit(r.employee_id, 'clockInTime', e.target.value)} /></td>
                  <td className="p-1"><input className="w-20 border rounded px-1" value={val('clockOutTime', 'clock_out_time') || ''} onChange={(e) => setEdit(r.employee_id, 'clockOutTime', e.target.value)} /></td>
                  <td className="p-1"><input className="w-16 border rounded px-1" value={val('reasonCode', 'reason_code') || ''} onChange={(e) => setEdit(r.employee_id, 'reasonCode', e.target.value)} /></td>
                  <td className="p-2">{r.normal_working_hours ?? '—'}</td>
                  <td className={`p-2 ${r.lateness_minutes > 0 ? 'text-red-600' : ''}`}>{r.lateness_minutes ?? 0}</td>
                  <td className="p-2">{r.under_minutes ?? 0}</td>
                  <td className="p-2">{otTotal}</td>
                  <td className="p-2 text-center"><Button variant="secondary" onClick={() => saveRow(r)} disabled={!r.id}>Save</Button></td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {!rows.length && <div className="p-6 text-center text-gray-500 text-sm">No records loaded — pick a date and Load.</div>}
      </div>
    </div>
  );
}
